// extracted by mini-css-extract-plugin
export default {"r_l":"_6b7b04eb3f _7cb796ad91","t":"bbc780002b"};